const HouseHill = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 7.917a.417.417 0 0 1-.296-.121L7.5 1.837 1.546 7.796a.417.417 0 0 1-.588-.588l6.25-6.25a.417.417 0 0 1 .588 0l6.25 6.25a.417.417 0 0 1-.296.709Z"
        fill="#9C9C9C"
      />
      <path
        d="m7.5 3.246-5 5.016v5.071a.833.833 0 0 0 .833.834H6.25V10h2.5v4.167h2.917a.833.833 0 0 0 .833-.834v-5.1l-5-4.987Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default HouseHill;
